<script setup>
import LocalePrompt from '@/Components/LocalePrompt.vue'
import { usePage } from '@inertiajs/vue3'

const page = usePage()
</script>

<template>
  <div>
    <!-- Toon prompt alleen als user NIET is ingelogd -->
    <LocalePrompt v-if="!page.props.auth?.user" />
    <slot />
  </div>
</template>
